import * as actions from './getAllSecurityQuestionsActions';

const getAllSecurityQuestionsReducers = {
  [actions.USER_GET_ALL_SECURITY_QUESTIONS_SUCCESS_RECEIVED]: (
    state,
    { payload }
  ) => {
    state.allSecurityQuestions = payload;
    return state;
  },
};

export default getAllSecurityQuestionsReducers;
